var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[(_vm.requirements && _vm.requirements.length > 0)?_c('requirements',{attrs:{"requirements":_vm.requirements}}):_c('buro',{attrs:{"buro":_vm.buro,"loading":_vm.loading,"error":_vm.error},on:{"init":args => _vm.$emit('init', args),"retry":args => _vm.$emit('retry', args)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }